import {Component, OnInit} from '@angular/core';
import {environment} from '../../environments/environment';

import {AppComponent} from '../app.component'

import {HttpService} from '../services/HttpService';
import {NotificationService} from '../services/NotificationService';

// import { Http } from '@angular/http';


@Component({
    selector: 'app-report',
    templateUrl: './report.component.html',
    styleUrls: ['./report.component.scss'],
    providers: [HttpService, NotificationService]
})
export class ReportComponent implements OnInit {

    public User_Details: any = {
        brandadmins: []
    };
    public maxDate: Date = new Date();
    public filterOptions = {
        id: 0,
        startdate: '',
        enddate: '',
        images: 0,
    }
    public allBrands: any;

    constructor(
        public http: HttpService,
        public notification: NotificationService,
        public app: AppComponent
    ) {
    }

    ngOnInit() {
        this.User_Details = JSON.parse(localStorage.getItem('Admin_User_Details'));
        if (this.User_Details.role.id == 1) {
            this.app.loading = true;
            this.http.makeRequestPost(['admin/user/brands/get', {token: this.User_Details.token}])
            .subscribe(
                (response) => {
                    this.app.loading = false;
                    if (response.data) {
                        if (response.data.length) {
                            console.log(response.data);
                            this.allBrands = response.data;
                        } else {
                            this.notification.showNotification('Please make sure you have a working data connection');
                        }
                    } else {
                        this.notification.showNotification('Please make sure you have a working data connection');
                    }
                },
                (error) => {
                    this.notification.showNotification('Please make sure you have a working data connection');
                    this.app.loading = false;
                }
            )
        } else {
            this.filterOptions.id = this.User_Details.brandadmins[0].id;
        }
    }

    createReport() {
        this.app.loading = true;
        this.http.makeRequestPost(['admin/user/suggestion/createReport', {
            token: this.User_Details.token,
            filter: JSON.stringify(this.filterOptions)
        }]).subscribe(
            (resp) => {
                this.app.loading = false;
                console.log(resp);
                this.notification.showNotification('The report has been generated. Please allow popups in your browser in order to see the report generated.');
                window.open(environment.apiUrl + 'resources/assets/reports/' + resp.data);

            },
            (error) => {
                this.app.loading = false;
                console.log(error);
                this.notification.showNotification('Please make sure you have a working data connection');
            }
        )
    }

}



// WEBPACK FOOTER //
// ./src/app/report/report.component.ts